// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__16ZpL","main":"App_main__3ZkGI","AppDark":"App_AppDark__xr22L","mainDark":"App_mainDark__2yqvJ"};